export default "__VITE_ASSET__6990593e__"